import { useEffect } from 'react';
import { useWatch, type UseFormReturn } from 'react-hook-form';
import type { CreateTemplateFormValues } from '../schemas/documentTemplate.schema';
import { keyFromName } from '../utils/keyFromName';

/** Fills the key from the name until the user edits the key themselves. */
export function useKeyFromName(form: UseFormReturn<CreateTemplateFormValues>) {
  const name = useWatch({ control: form.control, name: 'name' });
  const keyEdited = Boolean(form.formState.dirtyFields.key);

  useEffect(() => {
    if (!keyEdited) form.setValue('key', keyFromName(name ?? ''));
  }, [form, name, keyEdited]);
}
